import TableConstructor from "layout/TableConstructor";
import {
  ListTrialFilterInput,
  PlatformTrialListOrderFields,
  PlatformTrialListOrderInput,
  TrialListQuery,
  useExaminationCompetencyListQuery,
} from "@generated/graphql";
import { useNavigate, useParams } from "react-router-dom";
import { getTestingPath } from "helpers/index";
import { RouteEnum } from "layout/TableConstructor/types";
import qs from "qs";
import columnConfig, { TrialItem } from "./tableConfig/columnConfig";
import filterConfig, { TrialFilter } from "./tableConfig/filterConfig";
import { TrialsListRefetch } from "../../types";

interface TrialListProps {
  trialsData: TrialListQuery["trials"] | undefined;
  loading: boolean;
  permanentFilter: ListTrialFilterInput | undefined;
  defaultOrder: PlatformTrialListOrderInput;
  refetch: TrialsListRefetch;
}

const TrialList = ({ trialsData, loading, permanentFilter, defaultOrder, refetch }: TrialListProps) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: competencyList, loading: competencylistLoading } = useExaminationCompetencyListQuery({
    variables: {
      examinationId: id!,
    },
    skip: !id,
  });

  const trials = trialsData?.data || [];
  const totalCount = trialsData?.totalCount || 0;
  const competencyListData = competencyList?.examination.competencyMap.competences;

  return (
    <TableConstructor<TrialItem, TrialFilter, PlatformTrialListOrderFields, undefined, RouteEnum.Trial>
      exportRoute={RouteEnum.Trial}
      data={trials}
      totalCount={totalCount}
      loading={loading || competencylistLoading}
      onRowClick={(trial) =>
        navigate({ pathname: getTestingPath("trial", trial.id), search: qs.stringify({ examinationId: id }) })
      }
      columnsConfig={columnConfig(competencyListData)}
      defaultVisibleColumnList={[
        "candidateNumericId",
        "candidateFullName",
        "completedAt",
        "status",
        "action",
        "score",
        ...(competencyListData ? competencyListData.map((c) => `competency${c.order}` as `competency${number}`) : []),
      ]}
      filtersConfig={filterConfig(competencyListData)}
      emptyPlaceholderText='Пока нет тестирований'
      refetch={refetch}
      storageName='examinationTrialList'
      settingsModalTitle='Список тестирований'
      defaultOrder={defaultOrder}
      permanentFilter={permanentFilter}
    />
  );
};

export default TrialList;
